<template>
  <div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap>
        <app-card :fullBlock="true" colClasses="xs12">
          <v-card-title>
            <v-dialog max-width="600px" v-model="addUserForm.dialog">
              <template v-slot:activator="{ on }">
                <v-btn outline color="primary" medium v-on="on">
                  <i class="material-icons">add</i>
                  {{$t('message.addNew')}}
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ $t('message.addNewStore') }}</span>
                </v-card-title>
                <v-card-text>
                  <v-form ref="addUserForm" v-model="addUserForm.valid">
                    <v-container grid-list-md pt-0>
                      <v-layout row wrap>
                        <v-flex md6 xs12>
                          <v-text-field
                            :rules="addUserForm.rules"
                            clearable
                            counter
                            :label="$t('message.name')"
                            prepend-icon="perm_identity"
                            required
                            v-model="addUserForm.name"
                          ></v-text-field>
                        </v-flex>

                        <v-flex md6 xs12>
                          <v-text-field
                            :rules="addUserForm.rules"
                            clearable
                            counter
                            :label="$t('message.lastname')"
                            prepend-icon="perm_identity"
                            required
                            v-model="addUserForm.lastName"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex xs12>
                          <v-text-field
                            :rules="addUserForm.emailRules"
                            clearable
                            :label="$t('message.email')"
                            prepend-icon="email"
                            required
                            type="text"
                            v-model="addUserForm.email"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex xs12>
                          <v-text-field
                            :rules="addUserForm.storeNameRules"
                            :label="$t('message.storeName')"
                            prepend-icon="zmdi-store"
                            required
                            type="text"
                            v-model="addUserForm.storeName"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex xs12>
                          <v-textarea
                            :counter="255"
                            :rules="addUserForm.storeDescriptionRules"
                            prepend-icon="zmdi-comment-alt-text"
                            :label="$t('message.description')"
                            v-model="addUserForm.storeDescription"
                          ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    outline
                    @click="addUserForm.dialog = false;"
                    color="error"
                    small
                  >{{ $t('message.cancel') }}</v-btn>
                  <v-btn
                    outline
                    :disabled="!addUserForm.valid"
                    @click="onAddUser()"
                    color="primary"
                    small
                  >{{ $t('message.add') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-spacer></v-spacer>
            <v-text-field
              append-icon="search"
              hide-details
              :label="$t('message.search')"
              single-line
              v-model="search"
            ></v-text-field>
          </v-card-title>

          <v-data-table :headers="headers" :items="users" :pagination.sync="pagination" :search="search">
            <template slot="headerCell" slot-scope="props">
              <span>{{ $t(`message.${props.header.text}`) }}</span>
            </template>
            <template v-if="props.item.store" slot="items" slot-scope="props">
              <td>{{ props.item.store.name || '' }}</td>
              <td>{{ `${props.item.name} ${props.item.lastname}` }}</td>
              <td>{{ props.item.statusName }}</td>
              <td>{{ props.item.created_at }}</td>
              <td>
                <v-chip v-if="!props.item.store"> Membresia caducada </v-chip>
                <span v-else>{{ props.item.store.subscription_finish_date }}</span>
              </td>
              <td class="text-left">
                <v-tooltip top>
                  <v-btn
                    outline
                    color="primary"
                    fab
                    icon
                    small
                    slot="activator"
                    :to="`store-details/${props.item.id}`"
                  >
                    <v-icon light>search</v-icon>
                  </v-btn>
                  <span>{{ $t('message.details') }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{on}">
                    <v-btn
                      outline
                      @click="openModalEdit(props.item)"
                      color="amber"
                      fab
                      icon
                      small
                      v-on="on"
                    >
                      <v-icon class="zmdi zmdi-edit"></v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('message.edit') }}</span>
                </v-tooltip>
                <v-tooltip>
                  <template v-slot:activator="{on}">
                    <v-btn
                      outline
                      @click="openSubscription(props.item)"
                      color="light-blue"
                      fab
                      icon
                      small
                      v-on="on"
                    >
                      <v-icon class="zmdi zmdi-account-calendar"></v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('message.subscription') }}</span>
                </v-tooltip>
                <!-- <v-btn
                  @click="onDelete(props.item)"
                  class="trash-icon"
                  color="error"
                  dark
                  fab
                  icon
                  small>
                  <v-icon light>cancel</v-icon>
                </v-btn>-->
              </td>
            </template>
          </v-data-table>

          <v-dialog max-width="600px" v-model="editStoreForm.dialog">
            <v-card>
              <v-card-title>
                <span class="headline">{{ $t('message.edit') }}</span>
              </v-card-title>
              <v-card-text>
                <v-form ref="editStoreForm" v-model="editStoreForm.valid">
                  <v-container grid-list-md pt-0>
                    <v-layout row wrap>
                      <v-flex md6 xs12>
                        <v-text-field
                          :rules="editStoreForm.rules"
                          clearable
                          counter
                          :label="$t('message.name')"
                          prepend-icon="perm_identity"
                          required
                          v-model="editStoreForm.name"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-text-field
                          :rules="editStoreForm.rules"
                          clearable
                          counter
                          :label="$t('message.lastname')"
                          prepend-icon="perm_identity"
                          required
                          v-model="editStoreForm.lastname"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs12>
                        <v-text-field
                          :rules="editStoreForm.emailRules"
                          clearable
                          :label="$t('message.email')"
                          prepend-icon="email"
                          required
                          type="text"
                          v-model="editStoreForm.email"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs12>
                        <v-select
                          :items="storeStatus"
                          :rules="editStoreForm.statusRules"
                          item-text="status_name"
                          item-value="status"
                          :label="$t('message.status')"
                          prepend-icon="power_settings_new"
                          v-model="editStoreForm.status"
                        ></v-select>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs12>
                        <v-select
                          :items="showStatuses"
                          required
                          item-text="status_name"
                          item-value="status"
                          :label="$t('message.showInDirectory')"
                          prepend-icon="mdi-eye"
                          v-model="editStoreForm.showInDirectory"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  outline
                  @click="editStoreForm.dialog = false"
                  color="error"
                  small
                >{{ $t('message.cancel') }}</v-btn>
                <v-btn outline @click="onEdit()" color="primary" small>{{ $t('message.save') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <subscription-manage :dialog.sync="showSubscriptionModal" @on-save="updateSubscription"></subscription-manage>
        </app-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import api from "Api";
import { filterIt } from "Helpers/helpers";
import { mapActions, mapGetters } from "vuex";
import {
  GET_USERS,
  CREATE_USER,
  UPDATE_USER,
  GET_STATUSES,
  UPDATE_SUBSCRIPTIONS
} from "../../store/modules/users/actions.type.js";

import { UPDATE_STORE_ADMIN } from "../../store/modules/storeModule/actions.type";

import SubscriptionManage from "./SubscriptionManage";

export default {
  components: {
    SubscriptionManage
  },
  data() {
    return {
      showStatuses: [
        {
          status: 1,
          status_name: "Mostrar"
        },
        {
          status: 0,
          status_name: "Ocultar"
        }
      ],
      storeStatus: [
        {
          status: 1,
          status_name: "Habilitado"
        },
        {
          status: 2,
          status_name: "Deshabilitado"
        }
      ],
      addUserForm: {
        valid: false,
        dialog: false,
        name: "",
        lastName: "",
        email: "",
        roleName: "",
        // password: '',
        storeName: "",
        storeNameRules: [v => !!v || this.$t("message.errorStoreName")],
        storeDescription: "",
        storeDescriptionRules: [
          v => !!v || this.$t("message.errorStoreDescription")
        ],
        // confirmPassword: '',
        selectedRole: null,
        // showIconPassword: false,
        // showIconConfirmPassword: false,
        rules: [v => !!v || this.$t("message.errorName")],
        // passwordRules: [(v) => !!v || 'Please, enter the password', (v) => (v && v.length >= 8) || 'Min 8 characters'],
        // confirmPasswordRules: [(v) => v.length >= 8 || 'Min 8 characters', () => this.addUserForm.password === this.addUserForm.password || 'The password does not match'],
        rolesRules: [v => !!v || "Please, select a role"],
        emailRules: [
          v => !!v || this.$t("message.errorEmail"),
          v => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(v) || this.$t("message.invalidEmail");
          }
        ]
      },

      editStoreForm: {
        valid: false,
        dialog: false,
        name: "",
        lastname: "",
        email: "",
        role_id: "",
        store_id: null,
        showInDirectory: false,
        // password: '',
        // confirmPassword: '',
        selectedRole: null,
        status: null,
        // showIconPassword: false,
        // showIconConfirmPassword: false,
        rules: [v => !!v || this.$t("message.errorName")],
        // passwordRules: [(v) => v.length >= 8 || 'Min 8 characters'],
        rolesRules: [v => !!v || "Please, select a role"],
        emailRules: [
          v => !!v || this.$t("message.errorEmail"),
          v => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(v) || this.$t("message.invalidEmail");
          }
        ],
        statusRules: [v => !!v || this.$t("message.errorStatus")],
        _method: "put"
      },
      search: "",
      headers: [
        { text: "storeName", sortable: true, value: "store.name" },
        { text: "ownerName", sortable: true, value: "name" },
        //{ text: 'email', sortable: true, value: 'email' },
        { text: "status", sortable: true, value: "statusName" },
        { text: "createDate", sortable: true, value: "created_at" },
        { text: "expireDate", sortable: true, value: "store.subscription_finish_date"},
        //{ text: "totalSales", sortable: true, value: "store.total_sales" },
        { text: "actions", sortable: false, value: "" }
      ],
      usersList: [],
      rolesObject: {},
      loader: false,
      selected: null,
      selectedUserEdit: null,
      y: "top",
      selectedUser: null,
      showSubscriptionModal: false,
      pagination: {
        descending: true,
        rowsPerPage: 10,
        //page: 1,
        sortBy: 'created_at',
      },
    };
  },
  mounted() {
    this.getUsers();
  },
  computed: {
    ...mapGetters(["users", "statuses", "statusName"]),
    page() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  methods: {
    getUsers() {
      this.$store.dispatch(GET_USERS);
    },
    onAddUser() {
      if (this.$refs.addUserForm.validate()) {
        this.$store.dispatch(CREATE_USER, {
          name: this.addUserForm.name,
          lastname: this.addUserForm.lastName,
          email: this.addUserForm.email,
          store_name: this.addUserForm.storeName,
          store_description: this.addUserForm.storeDescription
        });
        this.addUserForm.dialog = false;
        this.resetAddUserForm();
      }
    },
    onEdit() {
      if (this.$refs.editStoreForm.validate()) {
        this.$store.dispatch(UPDATE_USER, {
          id: this.selectedUserEdit.id,
          name: this.editStoreForm.name,
          lastname: this.editStoreForm.lastName,
          email: this.editStoreForm.email,
          // password: this.editStoreForm.password,
          status_id: this.editStoreForm.status
        });

        this.$store.dispatch(UPDATE_STORE_ADMIN, {
          id: this.editStoreForm.store_id,
          show: this.editStoreForm.showInDirectory
        });

        this.editStoreForm.dialog = false;
        this.resetUserEditForm();
      }
    },
    openModalEdit(selectedUser) {
      this.editStoreForm.dialog = true;
      this.selectedUserEdit = selectedUser;
      this.editStoreForm.name = selectedUser.name;
      this.editStoreForm.lastname = selectedUser.lastname;
      this.editStoreForm.email = selectedUser.email;
      this.editStoreForm.status = selectedUser.status_id;
      this.editStoreForm.showInDirectory = selectedUser.store.show;
      this.editStoreForm.store_id = selectedUser.store.id;
      // this.editStoreForm.role_id = selectedUser.roles[0].name || 'No roles available'
    },
    openSubscription(user) {
      this.selectedUser = user;
      this.showSubscriptionModal = true;
    },
    resetUserEditForm() {
      this.editStoreForm = Object.assign(this.editStoreForm, {
        valid: false,
        dialog: false,
        name: "",
        lastname: "",
        email: "",
        role_id: "",
        // password: '',
        // confirmPassword: '',
        selectedRole: null
        // showIconPassword: false,
        // showIconConfirmPassword: false
      });
      this.$refs.editStoreForm.resetValidation();
    },
    resetAddUserForm() {
      this.addUserForm = Object.assign(this.addUserForm, {
        valid: false,
        dialog: false,
        name: "",
        lastName: "",
        email: "",
        roleName: "",
        // password: '',
        // confirmPassword: '',
        selectedRole: null,
        // showIconPassword: false,
        // showIconConfirmPassword: false
        storeName: "",
        storeDescription: ""
      });
      this.$refs.addUserForm.resetValidation();
    },
    updateSubscription(months) {
      this.$store.dispatch(UPDATE_SUBSCRIPTIONS, {
        store_id: this.selectedUser.store.id,
        months: months
      });
    }
  }
};
</script>
